module.exports = __webpack_public_path__ + "static/img/phone-background.a12d7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-background.png
// module id = R5Fx
// module chunks = 1